/* Minent — page machine. Données 100 % live côté navigateur :
 * - cours + réseau : api.minent.eu (2 min / 10 min)
 * - historique 12 mois : CoinGecko + Blockchair/blockchain.info (CORS), à la volée
 * - prix/stock produit : rendus par Liquid (toujours frais côté serveur)
 * Le HTML contient des valeurs figées de secours ; ce script les remplace.
 */
(function () {
  "use strict";
  var root = document.getElementById("mp-root");
  var dataEl = document.getElementById("mp-data");
  if (!root || !dataEl) return;
  var D = JSON.parse(dataEl.textContent);
  var TWO32 = 4294967296;
  var UNIT = { "TH/s": 1e12, "GH/s": 1e9, "MH/s": 1e6, "KH/s": 1e3, "Ksol/s": 1e3 };
  var HPS = D.hr * (UNIT[D.u] || 1);
  var KWH_DAY = D.w / 1000 * 24;
  var L = root.dataset; // libellés traduits (dayshort, j, months, today, live, loading)

  var NET = { main: D.net_fallback, doge: D.net_doge || null };
  var PRICES = {}; // cg id -> eur
  var state = { el: 0, rev: D.baked.rev };

  function fmt(v, d) {
    return v.toLocaleString("fr-FR", { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  function setText(sel, txt) {
    var e = root.querySelector(sel);
    if (e) e.textContent = txt;
  }

  /* ---------- calculs ---------- */
  function revFromNet(net, hps, price) {
    if (!net || !price) return 0;
    if (net.type === "diff") return hps * 86400 * net.reward / (net.diff * TWO32) * price;
    return (hps / net.nh) * (86400 / net.bt) * net.reward * price;
  }
  function revNow() {
    var p = PRICES[D.cg];
    if (!p) return D.baked.rev;
    var r = revFromNet(NET.main, HPS, p);
    if (D.merged && NET.doge && PRICES[D.cg_doge]) {
      r += revFromNet(NET.doge, HPS, PRICES[D.cg_doge]);
    }
    return r;
  }

  /* ---------- rendu live ---------- */
  function refresh() {
    var rv = revNow();
    state.rev = rv;
    var roi = D.price && rv > 0 ? Math.ceil(D.price / rv) : null;
    setText("#mp-rev", "+" + fmt(rv, 2) + " €");
    setText("#mp-revmon", "+" + fmt(rv * 30.4, 0) + " €");
    if (roi) {
      setText("#mp-roi", fmt(roi, 0) + L.j);
      setText("#mp-roisub", "≈ " + fmt(roi / 30.4, 1) + " " + L.months + " · " + L.horselec);
    }
    setText("#mp-be", fmt(rv / KWH_DAY, 2));
    var cp = PRICES[D.cg];
    if (cp) setText("#mp-coinprice", fmt(cp, cp >= 1 ? 2 : 4) + " €");
    if (NET.main.type === "diff") {
      setText("#mp-netfacts", fmt(NET.main.reward, 2) + " " + D.c + "/" + L.block +
        " · " + L.diff + " " + fmt(NET.main.diff / 1e12, 1) + " T");
    } else {
      setText("#mp-netfacts", fmt(NET.main.reward, 2) + " " + D.c + "/" + L.block);
    }
    /* duel + similaires (revenus live) */
    Array.prototype.forEach.call(root.querySelectorAll("[data-mrev]"), function (e) {
      try {
        var md = JSON.parse(e.getAttribute("data-mrev"));
        var p2 = PRICES[md.cg];
        if (!p2) return;
        var r2 = revFromNet(md.net, md.hr * (UNIT[md.u] || 1), p2);
        if (md.merged && NET.doge && PRICES[D.cg_doge || "dogecoin"]) {
          r2 += revFromNet(NET.doge, md.hr * (UNIT[md.u] || 1), PRICES["dogecoin"]);
        }
        e.textContent = "+" + fmt(r2, 2) + " €" + (e.hasAttribute("data-suffix") ? e.getAttribute("data-suffix") : "");
        var roiCell = e.closest("tr") && e.closest("tr").querySelector("[data-mroi]");
        if (roiCell) {
          var pr = parseFloat(roiCell.getAttribute("data-mroi"));
          roiCell.textContent = pr && r2 > 0 ? fmt(Math.ceil(pr / r2), 0) + L.j : "—";
        }
      } catch (err) {}
    });
    sim();
    setText("#mp-live", L.live);
    var lv = root.querySelector("#mp-live");
    if (lv) lv.classList.add("ok");
  }

  /* ---------- simulateur ---------- */
  function sim() {
    var cost = KWH_DAY * state.el, pf = state.rev - cost;
    function put(id, v, dec) {
      var e = root.querySelector(id);
      if (!e) return;
      e.textContent = (v >= 0 ? "+" : "−") + fmt(Math.abs(v), dec) + " €";
      e.className = "v num " + (v >= 0 ? "pos" : "neg");
    }
    put("#sim-day", pf, 2); put("#sim-mon", pf * 30.4, 0); put("#sim-yr", pf * 365, 0);
    setText("#sim-el", fmt(cost, 2) + " €");
    setText("#sim-roi", D.price && pf > 0 ? fmt(Math.ceil(D.price / pf), 0) + L.j : "—");
    /* tableau contrats */
    Array.prototype.forEach.call(root.querySelectorAll("[data-tarif]"), function (tr) {
      var t = parseFloat(tr.getAttribute("data-tarif"));
      var p2 = state.rev - KWH_DAY * t;
      var c1 = tr.querySelector(".ct-pf"), c2 = tr.querySelector(".ct-mon"), c3 = tr.querySelector(".ct-roi");
      if (c1) { c1.textContent = (p2 >= 0 ? "+" : "−") + fmt(Math.abs(p2), 2) + " €" + L.dayshort; c1.className = "num ct-pf " + (p2 >= 0 ? "pos" : "neg"); }
      if (c2) c2.textContent = p2 > 0 ? fmt(p2 * 30.4, 0) + " €" : "—";
      if (c3) c3.textContent = D.price && p2 > 0 ? fmt(Math.ceil(D.price / p2), 0) + L.j : "—";
    });
  }
  var slider = root.querySelector("#mp-el");
  if (slider) {
    slider.addEventListener("input", function () {
      state.el = parseFloat(slider.value) || 0;
      setText("#mp-elv", fmt(state.el, 2) + " €/kWh");
      sim();
    });
  }

  /* ---------- graphique historique (live, navigateur) ---------- */
  var MOIS = ["janv", "févr", "mars", "avr", "mai", "juin", "juil", "août", "sept", "oct", "nov", "déc"];
  var chartBox = root.querySelector("#mp-chart");
  var curSeries = (D.hist && D.hist.series) || null;

  function drawChart(series) {
    if (!chartBox || !series || series.length < 10) return;
    var W = 880, H = 300, PADL = 52, PADB = 30, PADT = 14;
    var vals = series.map(function (s) { return s[1]; });
    var ymin = 0, ymax = Math.max.apply(null, vals) * 1.08;
    function X(i) { return PADL + i / (series.length - 1) * (W - PADL - 12); }
    function Y(v) { return PADT + (1 - (v - ymin) / (ymax - ymin)) * (H - PADT - PADB); }
    var line = "", area = "";
    series.forEach(function (s, i) { line += (i ? "L" : "M") + X(i).toFixed(1) + "," + Y(s[1]).toFixed(1); });
    area = line + "L" + X(series.length - 1).toFixed(1) + "," + Y(ymin) + "L" + X(0).toFixed(1) + "," + Y(ymin) + "Z";
    var step = ymax < 8 ? 1 : ymax < 35 ? 5 : 10;
    var grid = "";
    for (var gv = 0; gv <= ymax; gv += step) {
      grid += '<line x1="' + PADL + '" x2="' + (W - 12) + '" y1="' + Y(gv).toFixed(1) + '" y2="' + Y(gv).toFixed(1) + '" class="grid"/>' +
        '<text x="' + (PADL - 8) + '" y="' + (Y(gv) + 3.5).toFixed(1) + '" class="axl" text-anchor="end">' + gv + ' €</text>';
    }
    var xl = "", seen = {};
    series.forEach(function (s, i) {
      var d = new Date(s[0] * 1000), k = d.getFullYear() + "-" + d.getMonth();
      if (d.getDate() <= 6 && !seen[k] && d.getMonth() % 2 === 1) {
        seen[k] = 1;
        xl += '<text x="' + X(i).toFixed(0) + '" y="' + (H - 8) + '" class="axl">' + MOIS[d.getMonth()] + " " + String(d.getFullYear()).slice(2) + "</text>";
      }
    });
    chartBox.innerHTML = '<svg viewBox="0 0 880 300" class="mp-svg" id="mp-svg">' +
      '<defs><linearGradient id="gP" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0" stop-color="#10b981" stop-opacity=".28"/><stop offset="1" stop-color="#10b981" stop-opacity="0"/></linearGradient></defs>' +
      grid + xl +
      '<path d="' + area + '" fill="url(#gP)"/>' +
      '<path d="' + line + '" fill="none" stroke="#10b981" stroke-width="2.5" stroke-linejoin="round"/>' +
      '<line id="mp-cross" x1="0" x2="0" y1="' + PADT + '" y2="' + (H - PADB) + '" stroke="#8B00FF" stroke-width="1" stroke-dasharray="3 3" opacity="0"/>' +
      '<circle id="mp-dot" r="4.5" fill="#10b981" stroke="#fff" stroke-width="2" opacity="0"/>' +
      '<circle cx="' + X(series.length - 1).toFixed(1) + '" cy="' + Y(vals[vals.length - 1]).toFixed(1) + '" r="4.5" fill="#10b981" stroke="#fff" stroke-width="2"/></svg>' +
      '<div class="mp-tip" id="mp-tip" hidden></div>';
    /* stats dérivées */
    var avg = vals.reduce(function (a, b) { return a + b; }, 0) / vals.length;
    setText("#mp-cum", "+" + fmt(avg * 365, 0) + " €");
    setText("#mp-best", "+" + fmt(Math.max.apply(null, vals), 2) + " €");
    if (D.price) setText("#mp-roiconst", fmt(D.price / (avg * 365) * 12, 1) + " " + L.months);
    setText("#mp-today", "+" + fmt(vals[vals.length - 1], 2) + " €" + L.dayshort);
    /* tooltip */
    var svg = chartBox.querySelector("#mp-svg"), tip = chartBox.querySelector("#mp-tip");
    var cross = chartBox.querySelector("#mp-cross"), dot = chartBox.querySelector("#mp-dot");
    svg.addEventListener("mousemove", function (ev) {
      var r = svg.getBoundingClientRect();
      var t = ((ev.clientX - r.left) / r.width * W - PADL) / (W - PADL - 12);
      t = Math.max(0, Math.min(1, t));
      var i = Math.round(t * (series.length - 1));
      var xp = X(i);
      cross.setAttribute("x1", xp); cross.setAttribute("x2", xp); cross.setAttribute("opacity", ".6");
      dot.setAttribute("cx", xp); dot.setAttribute("cy", Y(series[i][1])); dot.setAttribute("opacity", "1");
      var d = new Date(series[i][0] * 1000);
      tip.innerHTML = d.getDate() + " " + MOIS[d.getMonth()] + " " + d.getFullYear() +
        "<br><b>+" + fmt(series[i][1], 2) + " €" + L.dayshort + "</b>";
      tip.hidden = false;
      tip.style.left = (xp / W * 100) + "%";
      tip.style.top = (Y(series[i][1]) / H * 100) + "%";
    });
    svg.addEventListener("mouseleave", function () {
      tip.hidden = true; cross.setAttribute("opacity", "0"); dot.setAttribute("opacity", "0");
    });
  }
  if (curSeries) drawChart(curSeries);

  function histUrlDiff(chain) {
    var since = new Date(Date.now() - 365 * 86400e3).toISOString().slice(0, 10);
    return "https://api.blockchair.com/" + chain + "/blocks?a=date,avg(difficulty)&q=time(" + since + "..)";
  }
  function fetchJson(u) { return fetch(u).then(function (r) { if (!r.ok) throw 0; return r.json(); }); }

  function loadHistory() {
    if (!D.hist_live || !chartBox) return;
    var jobs = [fetchJson("https://api.coingecko.com/api/v3/coins/" + D.cg + "/market_chart?vs_currency=eur&days=365")];
    if (D.c === "BTC") {
      jobs.push(fetchJson("https://api.blockchain.info/charts/difficulty?timespan=1year&format=json&cors=true")
        .then(function (d) { return d.values; }));
    } else {
      var chain = { ZEC: "zcash", LTC: "litecoin", DOGE: "dogecoin" }[D.c];
      jobs.push(fetchJson(histUrlDiff(chain)).then(function (d) {
        return d.data.map(function (r) { return { x: Date.parse(r.date) / 1000, y: r["avg(difficulty)"] }; });
      }));
    }
    if (D.merged) {
      jobs.push(fetchJson("https://api.coingecko.com/api/v3/coins/dogecoin/market_chart?vs_currency=eur&days=365"));
      jobs.push(fetchJson(histUrlDiff("dogecoin")).then(function (d) {
        return d.data.map(function (r) { return { x: Date.parse(r.date) / 1000, y: r["avg(difficulty)"] }; });
      }));
    }
    Promise.all(jobs).then(function (res) {
      var prices = res[0].prices, diffs = res[1];
      function revAt(coin, diff, price) {
        var rw = NET.main.reward;
        if (coin === "ZEC") return HPS * 86400 * rw / (diff * 8192) * price;
        return HPS * 86400 * rw / (diff * TWO32) * price; /* diff-type */
      }
      var di = 0, out = [];
      prices.forEach(function (pp) {
        var ts = pp[0] / 1000;
        while (di + 1 < diffs.length && diffs[di + 1].x <= ts) di++;
        out.push([ts, revAt(D.c, diffs[di].y, pp[1])]);
      });
      if (D.merged && res[3]) {
        var dp = {}, dd = res[3], dj = 0;
        res[2].prices.forEach(function (pp) {
          var ts = pp[0] / 1000;
          while (dj + 1 < dd.length && dd[dj + 1].x <= ts) dj++;
          dp[Math.floor(ts / 86400)] = HPS * 86400 * (NET.doge ? NET.doge.reward : 10000) / (dd[dj].y * TWO32) * pp[1];
        });
        out = out.map(function (s) { return [s[0], s[1] + (dp[Math.floor(s[0] / 86400)] || 0)]; });
      }
      /* lissage 3 points puis ~120 points */
      var sm = out.map(function (s, i) {
        var w = out.slice(Math.max(0, i - 1), i + 2);
        return [s[0], w.reduce(function (a, b) { return a + b[1]; }, 0) / w.length];
      }).filter(function (_, i) { return i % 3 === 0; });
      if (sm.length > 30) drawChart(sm.map(function (s) { return [Math.round(s[0]), Math.round(s[1] * 10000) / 10000]; }));
    }).catch(function () { /* la version figée reste affichée */ });
  }

  /* ---------- live api.minent.eu ---------- */
  function loadLive() {
    fetchJson("https://api.minent.eu/prices.json").then(function (d) {
      Object.keys(d).forEach(function (k) { if (d[k] && d[k].eur) PRICES[k] = d[k].eur; });
      refresh();
    }).catch(function () {});
    fetchJson("https://api.minent.eu/network.json").then(function (d) {
      var n = (d.network || {})[D.c];
      if (n && n.nethash) {
        if (NET.main.type === "diff" && n.difficulty > 0) NET.main = { type: "diff", diff: n.difficulty, reward: n.block_reward };
        else if (NET.main.type === "nh" && n.nethash > 0 && n.block_time > 0) NET.main = { type: "nh", nh: n.nethash, bt: n.block_time, reward: n.block_reward };
      }
      var dg = (d.network || {}).DOGE;
      if (D.merged && dg && dg.difficulty > 0) NET.doge = { type: "diff", diff: dg.difficulty, reward: dg.block_reward };
      refresh();
    }).catch(function () {});
  }

  /* ---------- sticky ---------- */
  var sticky = root.querySelector("#mp-sticky"), buy = root.querySelector("#mp-buy");
  if (sticky && buy) {
    var onScroll = function () {
      var r = buy.getBoundingClientRect();
      sticky.hidden = (r.bottom > 0 && r.top < window.innerHeight);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    onScroll();
  }

  sim();
  loadLive();
  loadHistory();
  setInterval(loadLive, 120000);
})();
